export const ERROR_TEXTS = {
  REQUIRED: 'Обов`язкове поле',
  NO_AVAILABLE_DAYS: 'Дні відпустки вичерпано',
  SELF_ADM_MANAGER: 'Неправильний адміністративний керівник',
  SELF_FN_MANAGER: 'Неправильний функціональний керівник'
};
